"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const Button_1 = require("@Components/Buttons/Button");
const permission_actions_1 = require("@App/enum/permission-actions");
const contexts_1 = require("@App/contexts");
const MyUserGroupsMapped_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/AssignedPermissionGroups/MyUserGroupsMapped"));
const UsersForUserTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/AssignedPermissionGroups/UsersForUserTable"));
const AssignedPermissionGroups = (props) => {
    const { userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { editIsDisabled, setEditIsDisabled, onCancelEdit, onOpenConfirmPopup, myUserGroups, editActionsGroups, rightsholderUser, setMyUserGroups, setEditActionsGroups, } = props;
    const isSubmitDisabled = () => !editActionsGroups.length || myUserGroups.filter((item) => item.checked).length === 0;
    return (react_1.default.createElement("div", { className: 'permissions-wrapper' },
        react_1.default.createElement("div", { className: 'permissions-block' },
            react_1.default.createElement("p", { className: 'title small bold' }, "Assigned Permissions Group"),
            react_1.default.createElement("div", { className: 'buttons-block' }, editIsDisabled ? (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => setEditIsDisabled(false) }, "Edit")) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: () => onCancelEdit(rightsholderUser) }, "Cancel"),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => onOpenConfirmPopup(permission_actions_1.PermissionActions.changePermissions), disabled: isSubmitDisabled() || userStore.isInternal }, "Save")))),
            react_1.default.createElement(MyUserGroupsMapped_1.default, { myUserGroups: myUserGroups, rightsholderUser: rightsholderUser, setMyUserGroups: setMyUserGroups, editIsDisabled: editIsDisabled, setEditActionsGroups: setEditActionsGroups })),
        react_1.default.createElement("div", { className: 'people-block' },
            react_1.default.createElement("p", { className: 'title small bold' }, "Others with similar permissions"),
            react_1.default.createElement(UsersForUserTable_1.default, null))));
};
exports.default = (0, mobx_react_1.observer)(AssignedPermissionGroups);
